<script lang="ts">
  // packages
  import { intcomma, pluralize } from 'journalize';

  // types
  // import type { Readable } from 'svelte/store';
  // import type { OfficeTrend } from '../interfaces';

  /**
  * A readable Svelte store of an individual Race.
  *
  *  @type {import('../types.d').OfficeTrend}
  */
  export let feed;
  export let includeMidline = true;

  /**
 * @type {string}
 */

  // const levelText = {
  //   ''
  // }


  // determine if this is a us house or us senate or gov race
  // only us house and us senate have the "caucus with ..." data fields
  // see if such field exists to determine whether to show

  $: hasCaucusData = $feed.others_caucus_with_dem ? true : false;
  $: othersCaucusWithDem = hasCaucusData ? $feed.others_caucus_with_dem : null;
  $: othersCaucusWithGop = hasCaucusData ? $feed.others_caucus_with_gop : null;

  $: totalDems = $feed.dem.won + $feed.dem.holdovers;
  $: totalCaucusWithDems = (othersCaucusWithDem ? othersCaucusWithDem.won : 0) + (othersCaucusWithDem ? othersCaucusWithDem.holdovers : 0);
  $: totalGop = $feed.gop.won + $feed.gop.holdovers;
  $: totalCaucusWithGOP = (othersCaucusWithGop ? othersCaucusWithGop.won : 0) + (othersCaucusWithGop ? othersCaucusWithDem.holdovers : 0);
  $: totalOther = $feed.others.won + $feed.others.holdovers;
  $: total = totalDems + totalCaucusWithDems + totalGop + totalCaucusWithGOP + totalOther;

  $: demNet = $feed.dem.net_winners;
  $: gopNet = $feed.gop.net_winners;
  $: othersNet = $feed.others.net_winners;
  $: caucusWithDemNet = (othersCaucusWithDem ? othersCaucusWithDem.net_winners : 0);
  $: caucusWithGopNet = (othersCaucusWithGop ? othersCaucusWithGop.net_winners : 0);
  $: totalDemNet = demNet + caucusWithDemNet;
  $: totalGopNet = gopNet + caucusWithGopNet;
  
  $: demWidth = ((totalDems + totalCaucusWithDems) / $feed.total) * 100;
  $: gopWidth = ((totalGop + totalCaucusWithDems) / $feed.total) * 100;
  $: otherWidth = (totalOther / $feed.total) * 100;
  $: remainingWidth = (($feed.total - total) / $feed.total) * 100;

  $: otherExists = ($feed.others.won + $feed.others.holdovers) > 0;

  $: seatsUpForElection = hasCaucusData ? $feed.total - $feed.dem.holdovers - $feed.gop.holdovers - othersCaucusWithDem.holdovers - othersCaucusWithGop.holdovers - $feed.others.holdovers : $feed.total - $feed.dem.holdovers - $feed.gop.holdovers - $feed.others.holdovers;


  // aria label from here
  // if statement to determine which level
  // us house - ntl page

  // $: otherSentence = otherExists ? `Other or third-party candidates have ${totalOther} seats.` : '';

  let leadingText;

  function getSeatsUpforElection(d) {
    let officeName = d.office_name;
    let totalSeats = d.total;
    if (officeName == 'U.S. Senate') {
      return 'A third of seats are up for election.'
    } else if ((officeName == 'U.S. House') && (totalSeats == 435)) {
      return `All ${totalSeats} seats are up for election.`
    } else if ((officeName == 'U.S. House') && (totalSeats == 52)) {
      return `All ${totalSeats} California seats in the U.S. House are up for election.`
    } else if (officeName == 'Governor') {
      return `${seatsUpForElection} gubernatorial seats are up for election.`
    } else {
      return ''
    }
  }

  function getCaucusWithSentence(d) {
    if (d > 0) {
      return `, including ${d} third-party candidate${pluralize(Math.abs(d))} who ${d > 1 ? 'caucus' : 'caucuses'} with the party.`
    } else {
      return '.'
    }
  }

  $: if (totalDems > totalGop) { // dem leading
    leadingText = `Democrats are leading with ${totalDems + totalCaucusWithDems} seat${pluralize(Math.abs(totalDems + totalCaucusWithDems))}${getCaucusWithSentence(totalCaucusWithDems)} Republicans have ${totalGop + totalCaucusWithGOP} seat${pluralize(Math.abs(totalGop + totalCaucusWithGOP))}${getCaucusWithSentence(totalCaucusWithGOP)} Other or third-party candidates have ${totalOther} seat${pluralize(Math.abs(totalOther))}.`
    } else if (totalGop > totalDems) { // gop leading
      leadingText = `Republicans are leading with ${totalGop + totalCaucusWithGOP} seat${pluralize(Math.abs(totalGop + totalCaucusWithGOP))}${getCaucusWithSentence(totalCaucusWithGOP)} Democrats have ${totalDems + totalCaucusWithDems} seat${pluralize(Math.abs(totalDems + totalCaucusWithDems))}${getCaucusWithSentence(totalCaucusWithDems)} Other or third-party candidates have ${totalOther} seat${pluralize(Math.abs(totalOther))}.`
    } else if ((totalDems === totalGop) && (totalDems > 0) && (totalGop > 0)) { // tied at not 0
      leadingText = `Democrats and Republicans are tied with ${totalGop + totalCaucusWithGOP} seat${pluralize(Math.abs(totalGop + totalCaucusWithGOP))} each. ${ (totalCaucusWithDems > 0) && (totalCaucusWithGOP === 0) ? `Democrats have ${totalCaucusWithDems} other or third-party candidates caucusing with their party` : (totalCaucusWithGOP > 0) && (totalCaucusWithDems === 0) ? `Republicans have ${totalCaucusWithGOP} other or third-party candidates caucusing with their party.` : `Democrats have ${totalCaucusWithDems} other or third-party candidates caucusing with their party, and Republicans have ${totalCaucusWithGOP}.`} Other or third-party candidates have ${totalOther} seat${pluralize(Math.abs(totalOther))}.`
    } else if (totalOther > (totalDems + totalGop)) { // other is leading
      leadingText = `Other or third-party candidates are leading with ${totalOther} seat${pluralize(Math.abs(totalOther))}. Democrats have ${totalDems + totalCaucusWithDems} seat${pluralize(Math.abs(totalDems + totalCaucusWithDems))}, which include ${totalCaucusWithDems} other or third-party candidates who caucus with the party. Republicans have ${totalGop + totalCaucusWithGOP} seat${pluralize(Math.abs(totalGop + totalCaucusWithGOP))}, which include ${totalCaucusWithGOP} other or third-party candidates who caucus with the party. Other or third-party candidates have ${totalOther} seat${pluralize(Math.abs(totalOther))}.`
    } else if ((totalDems === 0) && (totalGop === 0) && (totalOther === 0)) { // no results yet
      leadingText = `There are no results yet.`
    }

  function getNetSeats(demNet, gopNet,f){
   if ((demNet === 0) && (gopNet === 0) && (f.dem.votes >= 0) && (f.gop.votes >= 0)) { // neither or tied at 0
    return 'Neither party has flipped a seat.'
   } else if ((demNet > 0) && (gopNet <= 0)) { // only dem
    return `Democrats have flipped ${demNet} new seat${pluralize(Math.abs(demNet))}.`
   } else if ((gopNet > 0) && (demNet <= 0)) { // only gop
    return `Republicans have flipped ${gopNet} new seat${pluralize(Math.abs(gopNet))}.`
   } else if ((gopNet !== 0) && (demNet !== 0) && (demNet == gopNet)) { // tied at not 0
    return `Democrats and Republicans have each flipped ${gopNet} new seat${pluralize(Math.abs(gopNet))}.`
   } else if ((demNet > 0) && (gopNet > 0) && (demNet !== gopNet)) { // not tied, each > 0
    return `Democrats have flipped ${demNet} new seat${pluralize(Math.abs(demNet))} and Republicans have flipped ${gopNet} new seat${pluralize(Math.abs(gopNet))}.`
   } else {
    return ""
   }
  }

  function getFirstSentence(officeName, totalSeats) {
    // find the level
    if (officeName === 'U.S. Senate') {
      return `Bar chart shows the balance of power between Republicans and Democrats in the U.S. Senate.`
    } else if ((officeName == 'U.S. House') && (totalSeats == 435)) {
      return `Bar chart shows the balance of power between Republicans and Democrats in the U.S. House of Representatives.`
    } else if ((officeName == 'U.S. House') && (totalSeats == 52)) {
      return `Bar chart shows the balance of power between Republicans and Democrats among California's seats in the U.S. House of Representatives.`
    } else if (officeName === 'Governor') {
      return `Bar chart shows the balance of power between Republican and Democratic Governors.`
    } else {
      return
    }
  }

  function getThreshold(officeName, totalSeats){
    if ((officeName !== 'Governor') && (totalSeats !== 52)) { // if not gov and not ca us house
      return `A party needs at least ${Math.ceil(totalSeats / 2)} seats to control the chamber.`
    } else {
      return ''
    }
  }
  
  let ariaLabel;

  function generateAriaLabel(f) {
    let aria = `${getFirstSentence(f.office_name, f.total)} ${getSeatsUpforElection(f)} ${getThreshold(f.office_name, f.total)} ${leadingText} ${getNetSeats(totalDemNet, totalGopNet,f)}`
    return aria;
  }

</script>

<div role="presentation" class="w-full position-relative text-sans-serif space-y-n2" aria-label={generateAriaLabel($feed)}>
  <dl class="display-flex justify-between leading-none mb-14">
    <div class="text-left color-dem-dark" style="width: 40%;">
      <dd class="text-5xl mb-11">{totalDems + totalCaucusWithDems}</dd>
      <dt class="party-label text-medium">Democrats 
        {#if hasCaucusData && totalCaucusWithDems > 0}
        <span class="desktop-only">({totalDems}), Other ({totalCaucusWithDems})</span>
        {/if}
      </dt>
    </div>

    <div class="to-win-text">
      {#if includeMidline}
      <p class="m-0 to-win-text text-bold text-center">{Math.ceil($feed.total / 2)} seats</p>
      {/if}
    </div>
    <div class="text-right color-gop-dark" style="width: 40%;">
      <dd class="text-5xl mb-11">{totalGop + totalCaucusWithGOP}</dd>
      <dt class="party-label text-medium">Republicans 
        {#if hasCaucusData && totalCaucusWithGOP > 0}
          <span class="desktop-only">({totalGop}), Other ({totalCaucusWithGOP})</span>
          {/if}
        </dt>
    </div>
  </dl>
  <div class="position-relative">
    <div class="display-flex w-full bar-height">
      <div class="bg-dem l-bar" style="width: {demWidth}%" />
      {#if demWidth <= gopWidth}
        <div class="bg-other o-bar" style="width: {otherWidth}%;position: relative" >
        </div>
      {/if}
      {#if demWidth > gopWidth}
      <div class="bg-other" style="width: {otherWidth}%;position: relative">
      </div>

    {/if}
      {#if remainingWidth > 0}
        <div class="bg-neutral" style="width: {remainingWidth}%" />
      {/if}
      <div class="bg-gop r-bar" style="width: {gopWidth}%" />
    </div>
    {#if includeMidline}
      <div
        class="display-flex justify-center w-full h-full position-absolute top-0">
        <div class="balance-bar" />
        {#if otherExists}
        <div class="other-annotation-container position-absolute text-sm m-0" style="left:calc({(demWidth + (otherWidth/2))}% - 14px)">
          <div class="dashed-line-container">
            <div class="dashed-line"></div>
          </div>
          <p class="other-annotation m-0">{totalOther} other{pluralize(Math.abs(totalOther))}<span class="mobile-only asterisk">*</span><span class="desktop-only">, non-affiliated</span></p>
        </div>
        {/if}
      </div>
      {/if}
      
  </div>
  <div class="display-flex justify-between text-sm color-dark-grey mt-8">
    <div class="text-left leading-subtitle">
      <p class="color-dark-grey text-bold m-0">
        {#if totalDemNet === 0}
          No new seats
        {:else}
          { totalDemNet > 0 ? 'Gained' : 'Lost'}
          {Math.abs(totalDemNet)}
          seat{pluralize(Math.abs(totalDemNet))}
        {/if}
      </p>
    </div>
    <div class="text-right leading-subtitle">
      <p class="color-dark-grey text-bold m-0">
        {#if totalGopNet === 0}
          No new seats
        {:else}
          {totalGopNet > 0 ? 'Gained' : 'Lost'}
          {Math.abs(totalGopNet)}
          seat{pluralize(Math.abs(totalGopNet))}
        {/if}
      </p>
    </div>
  </div>
    <div class="legend-text-mobile text-sm leading-subtitle">
      {#if hasCaucusData && (totalCaucusWithDems > 0 ||totalCaucusWithGOP > 0 )}
      <p class="mt-40">Total includes third-party candidates caucusing with Democrats ({totalCaucusWithDems}) and Republicans ({totalCaucusWithGOP}).</p>
      {/if}
      {#if otherExists}
      <p class="{ (totalCaucusWithDems + totalCaucusWithGOP > 0)  ? 'mt-20' : 'mt-40'} o-footnote">*<span class="text-bold">Others</span> are non-affiliated party candidates</p>
      {/if}
    </div>
</div>